export const LOCAL_STORAGE_CONSTANT = {
  CURRENT_STORE: 'CURRENT_STORE'
};
